<template>
<v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex d-flex xs12 sm12 md12>
        <v-card color="transparent" flat>
          <v-card-text class="titleColorSystem">capital humano</v-card-text>
		  <p class="sci-prod-texto">
        En esta sección podrá consultar los productos derivados de la actividad de los investigadores del estado de 
        Durango, tales como artículos científicos, libros, registros de propiedad intelectual o industrial, entre otros.
      </p>
        </v-card>
      </v-flex>
      
	</v-layout>
	<div style="border: solid 1px; border-radius: 10px 10px 10px 10px;">
        <v-layout row wrap style="margin: auto 30px;">
          <v-flex d-flex>
            <v-layout row wrap>
              <v-flex
                d-flex
                md6 xs12
              >
                <v-select
                v-model="cap"
                :items="capital"
                item-value="name"
                class="text-xs-center"
                item-text="name"
                label="Tipo"
            >
			<template #selection="{ item }">
				<v-chip class="text-xs-center" v-model="cap" :color="getColor(item.name)" close dark>{{item.name}}</v-chip>
			</template>
			</v-select>
              </v-flex>
              <v-flex
                d-flex
                md6 xs12
              >
                <v-select
              v-model="year"
              :items="years"
              item-value="date"
              class="sci-prod-vselect"
              item-text="date"
              label="Indicar año"
              
            >
			<template #selection="{ item }">
				<v-chip class="text-xs-center" v-model="year" close dark>{{item.date}}</v-chip>
			</template>
			</v-select>
              </v-flex>
            </v-layout>
          </v-flex>

		  <v-flex d-flex xs12 sm12 md12>
        <v-layout row wrap>
			<ul class="grey--text" v-if="capCount"> Se encontraron {{capCount}} {{cap ? cap : ''}}</ul>
      <ul class="grey--text" v-else>Sin resultados</ul>
		</v-layout>
	  </v-flex>
        </v-layout>
      <v-layout row wrap style="margin: auto 30px;">
		  
      <v-flex d-flex xs12 sm12 md12>
		  <div style="overflow-x: scroll;">
			<v-toolbar flat color="white">
		<v-flex d-flex xs12 sm12 md4>
        <v-layout row wrap>
          <vue-excel-xlsx
              class="sci-prod-excel"
              :data="capitalExcel.data"
              :columns="columns1"
              :filename="'Capital Humano'"
              :sheetname="'Capital Humano'"
            >
              Descargar resultados de {{cap}}
            </vue-excel-xlsx>
		</v-layout>
	  </v-flex>		
      
      		
			<v-spacer></v-spacer>
		<v-flex d-flex xs12 sm12 md4>
              <v-text-field
					v-model="search"
					append-icon="search"
					label="Buscar por nombre"
					hide-details
					clearable
					flat
				></v-text-field>
            
          </v-flex>	
    </v-toolbar>
			<v-data-table
              :headers="headers" 
              :items="capitalhumano.data" 
              item-key="id" class="elevation-1"
			  hide-actions
			  
              
            >
			<template v-slot:items="props">
								 
         		<!-- <td class="text-xs-left">{{ props.item.nombre }}</td>
				<td class="text-xs-left">{{ props.item.ap_pat }}</td>
				<td class="text-xs-left">{{ props.item.ap_mat }}</td> -->
				<!-- <td class="text-xs-left">{{ props.item.rol }}</td>
				<td class="text-xs-left">{{ props.item.nivel_proyecto }}</td>
				<td class="text-xs-left">{{ props.item.grado }}</td>
				<td class="text-xs-left">{{ props.item.fecha_obtencion }}</td> -->
				
				<td class="text-xs-left">{{ props.item.nombre_curso ? props.item.nombre_curso : "Sin Nombre" }}</td>
				<td class="text-xs-left"> <v-chip dark :color="getColor(props.item.tipo_capital)"> <v-avatar>
        <v-icon>check_circle</v-icon>
      </v-avatar> {{ props.item.tipo_capital ? props.item.tipo_capital : "Sin Tipo"}} </v-chip></td>
				<td class="text-xs-left">{{ props.item.institucion_otorgante ? props.item.institucion_otorgante : "Sin institucion"}}</td>
				<td class="text-xs-left">{{ props.item.area_conocimiento ? props.item.area_conocimiento : "Sin area de conocimiento"}}</td>
				<td class="text-xs-left">{{ props.item.fecha_obtencion_grado ? `${props.item.fecha_obtencion_grado.substring(0,4)}` : "Sin fecha"  }} </td>
				<!-- <td class="text-xs-left">{{ props.item.duracion_curso }}</td>  -->
                
			</template>
			<template v-slot:no-data>
				<v-alert :value="true" color="orange" icon="warning">
					Sin información. Por favor elija una categoría mediante el select :(
				</v-alert>
			</template>
			</v-data-table>
			<v-card-actions>
            <v-spacer></v-spacer>
            <pagination :limit="vPaginator.limit" :data="capitalhumano" @pagination-change-page="getCapitalHumano"></pagination>
			<v-spacer></v-spacer>
		  </v-card-actions>
        </div>
      </v-flex>
	  </v-layout>
	</div>
  </v-container>
	
</template>

<script>
import axios from 'axios'
import {mapState, mapActions} from 'vuex'
export default {
  name: "capital_humano",
  props: ["urlApi"],
  data() {
    return {
		columns1: [
        {label: "Nombre", field: "nombre_curso"},
		{label: "Tipo", field: "tipo_capital"},
		{label: "Institucion", field: "institucion_otorgante"},
		{label: "Area de Conocimiento", field: "area_conocimiento"},
		{label: "Fecha", field: "fecha_obtencion_grado"},
      ],
	  dialog: false,
	  capitalhumano: [],
      headers: [
        // {
        //   text:'Nombre',
        //   sortable: false
        // },
        // {
        //   text:'Apellido Paterno',
        //   sortable: false
        // },
        // {
        //   text: 'Apellido Materno',
        //   sortable: false
        // },
        // {
        //   text: 'Rol',
        //   sortable: false
        // },
        // {
        //   text: 'Nivel del proyecto',
        //   sortable: false
        // },
        // {
        //   text: 'Grado',
        //   sortable: false
        // },
        // {
        //   text: 'Fecha',
        //   sortable: false
        // },
        {
          text: 'Nombre',
          sortable: false,
		  class: 'primary--text',
        },
        {
          text: 'Tipo',
          sortable: false,
		  class: 'primary--text',
        },
        {
          text: 'Institución',
          sortable: false,
		  class: 'primary--text',
        },
        {
          text: 'Area de conocimiento',
          sortable: false,
		  class: 'primary--text',
        },
        {
          text: 'Fecha',
          sortable: false,
		  class: 'primary--text',
        },
        // {
        //   text: 'Duración del curso',
        //   sortable: false
        // }
      ],
      capital: [{id: 1, name: "Cursos de actualización impartidos"}, {id: 2, name: "Diplomados impartidos"}, {id: 3, name: "Tesis dirigidas"}],
      cap: null,
      years: [{id:1, date: 2012}, {id: 2, date: 2013}, {id: 3, date: 2014}, {id: 4, date: 2015}, {id: 5, date: 2016}, {id: 6, date: 2017}, {id: 7, date: 2018}, {id: 8, date: 2019}, {id: 9, date: 2020}],
      year: [],
      search: '',
      dialog: false,
      currentInvestigadorID: null,
      currentInvestigadorName: null,
      
      capitalExcel: {
        data:[],
        default: ()=>[]
      },
     
      vPaginator: {
        limit: 10
      },
    }
  },
  mounted(){ 
    // this.getCapitalHumano();
  },
  watch:{
	  
    cap: function(value){
     
        this.getCapitalHumano();
      
    },
    year: function(value){
     
        this.getCapitalHumano();
      
    },
    search: function(value){
     
        this.getCapitalHumano();
		this.getCapitalExcel();
    },
  },
  methods:{
    getCapitalHumano: function(page = 1){
      var url= process.env.VUE_APP_API_URL + `/api/capital-humano?page=${page}&query=${this.search}&firstQuery=Capital%20humano&secondQuery=${this.cap}&thirdQuery=${this.year ? this.year : ''}`;
      axios.get(url)
      .then(response => {this.capitalhumano = response.data})
      .catch(error => errorHandling(error));
    },
	 getCapitalExcel: function(){
      var url= process.env.VUE_APP_API_URL + `/api/capital-humano?perPage=500&page=1&query=${this.search}&firstQuery=Capital%20humano&secondQuery=${this.cap}&thirdQuery=${this.year ? this.year : ''}`;
      axios.get(url)
      .then(response => {this.capitalExcel = response.data})
      .catch(error => errorHandling(error));
    },

	getColor (tipo_capital) {
      if (tipo_capital == "Cursos de actualización impartidos") return 'indigo'
      else if (tipo_capital == "Diplomados impartidos") return 'blue'
      else if (tipo_capital == "Tesis dirigidas") return 'light-blue'
    },
	
    
  },
  created(){
    // this.getCapitalHumano();
  },
  computed:{
	  capCount: function(){
		  return this.capitalhumano.total
	  }
    
  }
}
</script>

 <style>
	.container.fluid {
    
    width: 85%;
}
	.sci-prod-excel{
		font-weight: bold;
		color: rgb(117, 180, 239);
		font-size: 1.1rem;
		border: 1px solid #ccc;
		padding: .4rem;
		margin: 1rem 0 1rem 0;
		border-radius: 5px;
		display: grid;
	}

	.sci-prod-title{
		margin: 3% auto 0%;
		text-transform: uppercase;
		color: rgba(255,196,0,.9);
		font-weight: bold;
		font-size: 1.5em;
	}
	.sci-prod-dot{
		font-weight: bold;
		color: rgba(0,152,255,.9)
	}
	.sci-prod-dot:before{
		content:'';
		display: inline-block;
		width: 90px;
		height: 1px;
		background: rgba(0,0,0,0.5);
		margin-right: 1.2%;
		border-radius: 1px 1px;
	}
	.sci-prod-dot:after{
		content:'';
		display: inline-block;
		width: 90px;
		height: 1px;
		background: rgba(0,0,0,0.5);
		margin-left: 1.2%;
		border-radius: 0 0 0 0;
	}
	.sci-prod-texto{
		width: 50%;
		margin: 1% auto;
		line-height: 1.5;
	}
</style>
